module.exports = __webpack_public_path__ + "media/img/popup_szkody-d0e59d89.svg";